import { GET_ALL_APPLIED_PROPERTIES } from "./types";
import axios from "axios";
import { toast } from "react-toastify";
const PROXY = process.env.REACT_APP_URL + "api/";

export const getAllAppliedProperties = (page, limit) => async (dispatch) => {
  const res = await axios.get(
    `${PROXY}apply/property/user/get?page=${page}&limit=${limit}`
  );
  dispatch({
    type: GET_ALL_APPLIED_PROPERTIES,
    payload: res?.data?.result,
  });
};

export const confirmRequestUser = (data) => async (dispatch) => {
  const res = await axios.post(`${PROXY}apply/property/user/confirm`, data);
  // toast.success(res.data.message);
  return res;
};

// export const unHideProperties=(id)=>async(dispatch)=>{
//     const res=await axios.delete(`${PROXY}hidden/${id}`)
//     return res;
// }
